import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Spinner } from 'react-activity';
import localStore from '../localStorage';
import { showNotification } from './action/NotificationAction';
import { myLog } from '../utils/Utility';
import { PATH } from '../utils/Constants';
import { RESPONSE_CONSTANT } from '../utils/ResponseConstant';
import Logo from '../utils/images/VirtuOwl_Logo_BrandMark_Pos (5).png';
import { forgetPassword, getUserInformation } from './action/UserAction';

class ForgotPassword extends Component {
    static propTypes = {
        history: PropTypes.any,
        showNotification: PropTypes.func,
        getUserInformation: PropTypes.func,
    };

    constructor(props) {
        super(props);
        this.state = {
            username: localStore.get('rememberMe') ? localStore.get('rememberMe').email : '',
            password: '',
            isdisable: false,
            isContactUs: false,
            email: '',
        };
    }

    /**
     * @description disable login during processing
     */
    disableLogin() {
        this.setState({ isdisable: !this.state.isdisable });
    }

    /**
     * @description invokes the login action
     */
    invokeLoginWebservice() {
        if (!this.state.username) {
            this.props.showNotification('Enter your Email Address', RESPONSE_CONSTANT.WARNING);
            return;
        }
        this.disableLogin();
        this.props.forgetPassword(this.state.username, (result) => {
            this.disableLogin();
            myLog('=========invokeLoginWebservice::::::::', result);
            if (result) {
                if (result.code === 200) {
                    this.props.showNotification(result.message, RESPONSE_CONSTANT.SUCCESS);
                    this.setState({ username: '' });
                    this.props.history.push(PATH.INDEX);
                } else {
                    this.props.showNotification(result.message, RESPONSE_CONSTANT.WARNING);
                }
            }
        });
    }

    /**
     * @description changes username in Onchange event
     * @param {Event} evt
     */
    updateInputValueUsername(evt) {
        this.setState({
            username: evt.target.value,
        });
    }

    //renderRequired
    renderRequired = (text) => {
        return (
            <div>
                {text}
                <span style={{ color: 'red', fontSize: '16px' }}> *</span>
            </div>
        );
    };

    /**
     * Render Page
     */
    render() {
        return (
            <div className="fixed h-full w-full left-0 top-0">
                <div className="w-full h-full flex items-center justify-center bg-neutral login-bg">
                    <div className="bg-white rounded-xl shadow-md flex sm:p-8 p-4 sm:py-12 py-6 gap-4 flex-col w-11/12 md:w-2/4 lg:w-1/3 xxl:w-1/4 2xl:w-4/12">
                        <img src={Logo} className="w-3/4 mx-auto my-4" alt="" srcSet="" />
                        <h1 className="mb-4 text-black text-xl">Forgot Password</h1>
                        <div className="flex border-black-10 w-full rounded-lg mb-2">
                            <div className="grow">
                                <input
                                    id="username"
                                    value={this.state.username}
                                    onChange={(value) => this.updateInputValueUsername(value)}
                                    onKeyPress={(e) => {
                                        if (e.key === 'Enter') this.invokeLoginWebservice();
                                    }}
                                    variant="filled"
                                    label={this.renderRequired('Email')}
                                    type="text"
                                    className="w-full py-2.5 leading-normal text-black placeholder:text-secondary text-lg px-2 rounded-lg"
                                    placeholder="Enter your email"
                                    maxLength={64}
                                />
                            </div>
                            <div className="flex items-center px-3">
                                <i className="fa-regular fa-envelope text-sm text-secondary"></i>
                            </div>
                        </div>
                        <div className="flex justify-between mb-4">
                            <div className="flex items-center gap-2"></div>
                            <Link
                                className="text-primary font-normal sm:text-base text-sm"
                                to={PATH.INDEX}
                            >
                                Back to Login?
                            </Link>
                        </div>
                        <button
                            onClick={() => this.invokeLoginWebservice()}
                            className="rounded-lg py-2.5 px-3 bg-primary text-white font-medium"
                            disabled={this.state.isdisable}
                        >
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                            >
                                {this.state.isdisable ? <Spinner color="#FFF" /> : 'Send'}
                            </div>
                        </button>{' '}
                    </div>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        showNotification: (message, type) => {
            dispatch(showNotification(message, type));
        },
        getUserInformation: (callback) => {
            dispatch(getUserInformation(callback));
        },
        forgetPassword: (emailId, callback) => {
            dispatch(forgetPassword(emailId, callback));
        },
    };
};

export default connect(null, mapDispatchToProps)(ForgotPassword);
